import { RESPONSE_STATUSES } from "@/api/constants";

export const getApiErrorStatus = (error: unknown): number => {
  if (typeof error !== "object" || error === null) {
    return 0;
  }

  const payload = error as { status?: unknown; statusCode?: unknown };

  return Number(payload.status ?? payload.statusCode ?? 0);
};

export const isResourceHttpError = (error: unknown): boolean => {
  const status = getApiErrorStatus(error);

  return (
    status === RESPONSE_STATUSES.FORBIDDEN ||
    status === RESPONSE_STATUSES.NOT_FOUND
  );
};
